import { useEffect, useState } from "react";
import _ from "underscore";
import { useAgileMatrixHeatmap } from "./useAgileMatrixHeatmap";
import { useTheme } from "../../../context/ThemeContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";

export const usePerformanceAuditMatrix = ({ options, filterValues, setFilterValues }) => {

    const { theme } = useTheme();
    const { colorCodes, getColorKey } = useAgileMatrixHeatmap({ filterValues, setFilterValues, fromOther: true });
    const [rowData, setRowData] = useState([]);
    const [selectedTab, setSelectedTab] = useState("complexity");
    const [columns, setColumns] = useState([])
    const [loader, setLoader] = useState(false);
    const tabs = [
        { key: "complexity", label: "Complexity" },
        { key: "logitivity", label: "Longitivity" },
    ]

    useEffect(() => {
        if (filterValues?.apiCall) {
            getAgilePerformanceMatrixData();
        }
    }, [filterValues?.apiCall])

    useEffect(() => {
        let cols = [{
            key: "user_display_name",
            label: "Employee",
            style: { width: "20%", borderRight: "1px solid #ddd", borderBottom: 0 },
            headerStyle: { paddinfLeft: "10px" },
            render: (row) => <div className="d-flex gap-2 align-items-center">
                <img className="rounded-circle" src={row?.profile_image_url || "./assets/grey-user-icon.png"} width={30} height={30} onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                <div>
                    <div className="fw-bold">{row?.user_display_name}</div>
                    <div className="text-secondary">{row?.project_role_name}</div>
                </div>
            </div>
        }]
        options?.[selectedTab]?.forEach(item => {
            cols?.push({
                key: item?.[selectedTab === "complexity" ? "issue_complexity_name" : "issue_logitivity_name"],
                label: item?.[selectedTab === "complexity" ? "issue_complexity_name" : "issue_logitivity_name"],
                style: { width: `${80 / options?.[selectedTab]?.length}%`, textAlign: "center", padding: 0, borderBottom: 0 },
                headerStyle: { textAlign: "center", borderRight: "1px solid #ddd" },
                render: (row) => {
                    const data = _.findWhere(row?.data, { [selectedTab === "complexity" ? "complexity_id" : "longitivity_id"]: item?.[selectedTab === "complexity" ? "issue_complexity_id" : "issue_logitivity_id"], user_display_name: row?.user_display_name });
                    const colorKey = getColorKey(data?.bid_accuracy || 0);
                    return (
                        <div className="fw-semibold py-1" style={{ backgroundColor: theme === "dark" ? "transparent" : colorCodes?.[colorKey]?.background, color: colorCodes?.[colorKey]?.color, borderWidth: "0px 1px 1px 0px", borderColor: colorCodes?.[colorKey]?.border, borderStyle: "solid" }}>
                            {data?.expected_hours ? <div>{data?.actual_hours} / {data?.expected_hours}</div> : <div>-</div>}
                            {data?.bid_accuracy ? <div>{parseFloat(data?.bid_accuracy?.toFixed(2))}%</div> : <div>-</div>}
                        </div>
                    )
                }
            })
        })
        setColumns(cols);
    }, [options, selectedTab, theme, rowData])

    const getAgilePerformanceMatrixData = async (isComplexity) => {
        try {
            setRowData([]);
            setLoader(true);
            const monthPairs = filterValues?.months?.map(item => { return `${item?.month?.toString()?.padStart(2, "0")}/${item?.year}` });
            const payload = {
                project_lead_user_codes: _.pluck(filterValues?.project_leads, "user_code")?.toString() || "",
                requested_user_codes: _.pluck(filterValues?.users, "user_code")?.toString() || "",
                project_ids: _.pluck(filterValues?.projects, "project_id")?.toString() || "",
                project_role_ids: (filterValues?.projects?.length === 0 ? "" : _.pluck(filterValues?.project_role, "project_role_id")?.toString()) || "",
                is_complexity: isComplexity !== undefined ? isComplexity : (selectedTab === "complexity"),
                month_year_range: monthPairs?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETAGILEPERFORMANCEAUDITMATRIX"), payload);
            if (!res?.body?.error_status) {
                const data = _.sortBy(res?.body?.data?.agile_performance_audit_matrix_data, "user_display_name");
                let dataArray = [];
                Object.entries(_.groupBy(data, "user_display_name"))?.forEach(([key, value]) => {
                    dataArray.push({
                        user_display_name: key,
                        project_role_name: value?.[0]?.project_role_name,
                        profile_image_url: value?.[0]?.profile_image_url,
                        data: value
                    })
                })
                setRowData(dataArray);
                setFilterValues(prev => ({ ...prev, apiCall: false }));
                (filterValues?.projects?.length === 0 && !_.isEmpty(filterValues?.project_role)) && setFilterValues((prev) => ({ ...prev, project_role: [] }));
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
            setFilterValues(prev => ({ ...prev, apiCall: false }));
        }
    }

    return { tabs, selectedTab, setSelectedTab, columns, rowData, loader, getAgilePerformanceMatrixData }
}